import { render, staticRenderFns } from "./agentplane-chat.vue?vue&type=template&id=143cc934&scoped=true"
import script from "./agentplane-chat.vue?vue&type=script&lang=js"
export * from "./agentplane-chat.vue?vue&type=script&lang=js"
import style0 from "./agentplane-chat.vue?vue&type=style&index=0&id=143cc934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cc934",
  null
  
)

export default component.exports